// Central content for A3 Global Marketing & Education
import {
  Globe, Megaphone, PhoneCall, Users, CalendarDays, Sparkles,
  GraduationCap, Briefcase, Brain, Cpu, LineChart, Palette,
  Layers, Target, PhoneForwarded, MessageSquare, FileCheck, TrendingUp,
} from "lucide-react";

export const IMAGES = {
  heroBg: "https://static.prod-images.emergentagent.com/jobs/55ef2d47-cf01-446f-a2b6-f1bed2e37e2d/images/79cf729c7ec72b67fc8da6bfd2fca39d064e601dc107a415374d6a5ef6587f27.jpeg",
  aiTech: "https://static.prod-images.emergentagent.com/jobs/55ef2d47-cf01-446f-a2b6-f1bed2e37e2d/images/b93a4c4275c48ca824fc65d1ff02f2d562a2839af119d55a7ef5bfc7535c2071.jpeg",
  ctaBg: "https://static.prod-images.emergentagent.com/jobs/55ef2d47-cf01-446f-a2b6-f1bed2e37e2d/images/2d2fbed4602fd3f6d30114c10adeb5928c7e369107fd2cc366df374101c03f97.jpeg",
  campus: "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=900&q=80",
  students: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=900&q=80",
  team: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1000&q=80",
  graduation: "https://images.unsplash.com/photo-1627556704290-2b1f5853ff78?auto=format&fit=crop&w=1600&q=80",
};

export const CONTACT = {
  phone: "9005890068",
  phoneDisplay: "+91 90058 90068",
  whatsapp: "919005890068",
  email: "hello@a3global.in",
  address: "2nd Floor, A.A. Complex, Park Road, Hazratganj, Lucknow, Uttar Pradesh, India",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Park+Road+Hazratganj+Lucknow",
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About A3", href: "#about" },
  { label: "What We Do", href: "#services" },
  { label: "For Institutions", href: "#institutions" },
  { label: "For Students", href: "#students" },
  { label: "Our Network", href: "#network" },
  { label: "Insights", href: "/insights", route: true },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { value: 2015, suffix: "", label: "Since We Started", plain: false },
  { value: 100, suffix: "+", label: "Education Professionals" },
  { value: 50, suffix: "+", label: "Partner Institutions" },
  { value: 10, suffix: "+", label: "Years in Education" },
  { value: 0, suffix: "", label: "Pan-India Student Reach", text: "Pan India" },
];

export const LIFECYCLE = [
  { n: "01", title: "BRAND", desc: "College positioning, branding and communication", icon: Palette },
  { n: "02", title: "TECHNOLOGY", desc: "Website, landing pages, CRM and digital infrastructure", icon: Cpu },
  { n: "03", title: "DEMAND GENERATION", desc: "SEO, Google, Meta and performance marketing", icon: Target },
  { n: "04", title: "LEAD MANAGEMENT", desc: "Lead capture, distribution and CRM", icon: Layers },
  { n: "05", title: "CALLING", desc: "Inbound and outbound calling operations", icon: PhoneForwarded },
  { n: "06", title: "COUNSELLING", desc: "Student engagement and admission counselling", icon: MessageSquare },
  { n: "07", title: "ADMISSIONS", desc: "Application, follow-up and conversion support", icon: FileCheck },
  { n: "08", title: "GROWTH", desc: "Analytics, optimization, branding and continuous growth", icon: TrendingUp },
];

export const SERVICES = [
  {
    n: "01", title: "Website & Technology", icon: Globe,
    tagline: "Build powerful digital experiences for colleges and universities.",
    items: ["College website development", "Admission portals", "Landing pages", "Lead capture systems", "CRM integration", "Application systems", "Student dashboards", "Analytics", "AI-enabled digital experiences", "Mobile-first development"],
    cta: "Build Your Digital Campus",
  },
  {
    n: "02", title: "Digital Marketing", icon: Megaphone,
    tagline: "Turn visibility into student demand.",
    items: ["Google Ads", "Meta Ads", "SEO", "Social media marketing", "Performance marketing", "Content marketing", "Video marketing", "Remarketing", "Lead generation", "Conversion optimization"],
    cta: "Grow Your Student Pipeline",
  },
  {
    n: "03", title: "Inbound & Outbound Calling", icon: PhoneCall,
    tagline: "Create a professional student communication engine.",
    items: ["Inbound enquiry handling", "Outbound lead calling", "Follow-up calling", "Application follow-up", "Counselling calls", "IVR", "AI-assisted calling", "Lead qualification", "Call analytics", "CRM-based calling workflows"],
    cta: "Build Your Calling Engine",
  },
  {
    n: "04", title: "Student Acquisition", icon: Users,
    tagline: "Help institutions reach the right students.",
    items: ["Student lead generation", "Campaign strategy", "Entrance-exam targeting", "Regional targeting", "Performance campaigns", "Lead qualification", "Admission funnel management", "Retargeting"],
    cta: "Acquire More Students",
  },
  {
    n: "05", title: "Education Events", icon: CalendarDays,
    tagline: "Create real-world student engagement.",
    items: ["MBA seminars", "Career counselling events", "College visits", "B-School meets", "Education fairs", "Campus drives", "Corporate events", "GDPI sessions", "Workshops", "Student engagement programs"],
    cta: "Create an Education Event",
  },
  {
    n: "06", title: "Branding & PR", icon: Sparkles,
    tagline: "Build a stronger institutional brand.",
    items: ["Brand strategy", "Creative campaigns", "Social media", "PR", "Reputation management", "Student stories", "Video production", "Campus storytelling", "Digital branding"],
    cta: "Build Your Institution Brand",
  },
  {
    n: "07", title: "Academic & Student Solutions", icon: GraduationCap,
    tagline: "An education technology and managed-services partner.",
    items: ["Student engagement", "Academic communication", "Learning ecosystem support", "Student experience", "Digital academic resources", "Career-oriented initiatives", "Industry interaction", "Student events"],
    cta: "Explore Student Solutions",
  },
  {
    n: "08", title: "Placement & Corporate Connect", icon: Briefcase,
    tagline: "Placement support and corporate-connect solutions.",
    items: ["Corporate outreach", "Recruiter engagement", "Placement communication", "Industry interaction", "Corporate events", "Employability initiatives", "Alumni engagement", "Career communication"],
    cta: "Explore Corporate Connect",
  },
];

export const WHY_A3 = [
  { title: "Education Expertise", desc: "Built specifically around education and student acquisition.", icon: GraduationCap },
  { title: "Technology First", desc: "Modern digital infrastructure for institutions.", icon: Cpu },
  { title: "Performance Driven", desc: "Marketing decisions powered by data.", icon: LineChart },
  { title: "Human + AI", desc: "Combine trained teams with AI-enabled technology.", icon: Brain },
  { title: "End-to-End", desc: "From awareness to admission and beyond.", icon: Layers },
  { title: "Long-Term Partner", desc: "We work as an extension of your internal team.", icon: Users },
];

export const OPERATING_MODEL = [
  "STRATEGY", "TECHNOLOGY", "MARKETING", "LEADS", "CALLING",
  "COUNSELLING", "ADMISSIONS", "RETENTION", "GROWTH",
];

export const AI_FEATURES = [
  "AI Lead Qualification", "AI Calling", "CRM Automation", "Marketing Analytics",
  "Student Behaviour Analytics", "Lead Scoring", "Automated Follow-ups",
  "Campaign Intelligence", "Dashboard Reporting",
];

export const EXTENDED_TEAM = [
  "Marketing Team", "Technology Team", "Calling Team", "Creative Team",
  "Performance Team", "Counselling Team", "Events Team", "Analytics Team",
];

export const TIMELINE = [
  { year: "2015", title: "A3 Begins" },
  { year: "2018", title: "Digital Education Expansion" },
  { year: "2020", title: "Technology & Lead Generation" },
  { year: "2022", title: "Multi-city Institution Network" },
  { year: "2024", title: "Integrated Education Growth Solutions" },
  { year: "2026", title: "50+ Institution Network" },
];

export const INSTITUTIONS = [
  { name: "FOSTIIMA Business School", city: "Delhi", logo: "/logos/fostiima.png" },
  { name: "I-Business Institute", city: "Greater Noida", logo: "/logos/ibi.png" },
  { name: "GNIOT", city: "Greater Noida", logo: "/logos/gniot.png" },
  { name: "IIBS", city: "Bangalore", logo: "/logos/iibs.png" },
  { name: "GIBS", city: "Bangalore", logo: "/logos/gibs.png" },
  { name: "RIIM", city: "Pune", logo: "/logos/riim.png" },
  { name: "ISMS", city: "Pune", logo: "/logos/isms.png" },
  { name: "ATLAS", city: "Mumbai", logo: "/logos/atlas.png" },
  { name: "D.Y. Patil", city: "Pune", logo: "/logos/dyp.png" },
  { name: "IBMR", city: "Gurugram", logo: "/logos/ibmr.png" },
  { name: "First Bridge Business School", city: "Gurugram", logo: "/logos/firstbridge.png" },
];

export const CASE_STUDIES = [
  {
    slug: "fostiima-business-school",
    name: "FOSTIIMA Business School", city: "Delhi",
    services: ["Website / Technology", "Digital Marketing", "Lead Generation", "Admissions"],
    tagline: "A full-funnel digital admissions engine for one of Delhi's leading PGDM institutions.",
    overview: "FOSTIIMA needed a modern digital presence that could match the strength of its academic brand and convert national-level PGDM demand into quality admissions. A3 works as FOSTIIMA's extended growth team across technology, marketing and the admission funnel.",
    deliverables: [
      { title: "Website / Technology", desc: "A conversion-focused institutional website with dedicated admission landing pages, lead capture and CRM-connected enquiry flows." },
      { title: "Digital Marketing", desc: "Always-on Google and Meta campaigns aligned to CAT, XAT and CMAT result cycles, backed by SEO and remarketing." },
      { title: "Lead Generation", desc: "Qualified PGDM aspirant pipelines with lead scoring, distribution and structured follow-up workflows." },
      { title: "Admissions", desc: "Application follow-up, counselling coordination and conversion support through the full admission season." },
    ],
    approach: ["Brand & positioning audit", "Digital infrastructure rebuild", "Performance campaign launch", "Lead-to-admission operations"],
    outcomes: ["A consistent, measurable enquiry pipeline across entrance-exam cycles", "Faster enquiry-to-counselling turnaround with CRM workflows", "A stronger digital brand presence in the Delhi PGDM landscape"],
  },
  {
    slug: "gniot",
    name: "GNIOT", city: "Greater Noida",
    services: ["Website / Technology", "Digital Marketing", "Calling", "Branding"],
    tagline: "Technology, calling operations and brand-building for a multi-program institution.",
    overview: "GNIOT partnered with A3 to modernise its digital infrastructure and build a professional student communication engine that could handle enquiry volume at scale.",
    deliverables: [
      { title: "Website / Technology", desc: "Program landing pages, admission portals and analytics-instrumented lead capture systems." },
      { title: "Digital Marketing", desc: "Performance marketing across Google and Meta with regional targeting across NCR and North India." },
      { title: "Calling", desc: "Inbound enquiry handling and outbound follow-up calling with CRM-based workflows and call analytics." },
      { title: "Branding", desc: "Creative campaigns, social media presence and campus storytelling to strengthen institutional recall." },
    ],
    approach: ["Enquiry-flow mapping", "Calling team & CRM setup", "Campaign scaling", "Brand content engine"],
    outcomes: ["Structured handling of high enquiry volumes without leakage", "Professional first-response experience for every aspirant", "A unified brand voice across digital touchpoints"],
  },
  {
    slug: "iibs",
    name: "IIBS", city: "Bangalore",
    services: ["Digital Marketing", "Lead Generation", "Calling", "Events"],
    tagline: "Pan-India student acquisition and engagement events for a Bangalore B-School.",
    overview: "IIBS works with A3 to reach MBA aspirants across India through performance marketing, structured calling and on-ground education events.",
    deliverables: [
      { title: "Digital Marketing", desc: "National campaigns targeted by entrance exam, region and program intent, with continuous conversion optimization." },
      { title: "Lead Generation", desc: "Multi-channel aspirant pipelines with qualification layers before counselling handoff." },
      { title: "Calling", desc: "Counselling-oriented calling operations covering enquiry, follow-up and application-stage conversations." },
      { title: "Events", desc: "Career counselling seminars, B-School meets and GDPI preparation sessions across key cities." },
    ],
    approach: ["Aspirant persona mapping", "Channel mix strategy", "Counselling funnel design", "Event calendar rollout"],
    outcomes: ["Reach into new regional aspirant markets beyond Karnataka", "Higher-quality counselling conversations via lead qualification", "Real-world engagement that supports digital demand"],
  },
  {
    slug: "riim",
    name: "RIIM", city: "Pune",
    services: ["Website / Technology", "Lead Generation", "Admissions", "Branding"],
    tagline: "A digital-first admission funnel and brand refresh for a rising Pune institute.",
    overview: "RIIM engaged A3 to build a modern admissions technology stack and a brand identity that stands out in Pune's competitive MBA/PGDM market.",
    deliverables: [
      { title: "Website / Technology", desc: "Rebuilt web experience with admission-first UX, application systems and student dashboards." },
      { title: "Lead Generation", desc: "Full-funnel demand generation aligned to MAH-CET, CAT and CMAT aspirant journeys." },
      { title: "Admissions", desc: "Application processing support, follow-up cadences and admission-season war-room operations." },
      { title: "Branding", desc: "Positioning, creative direction and student-story content across platforms." },
    ],
    approach: ["Competitive positioning study", "Web & funnel rebuild", "Demand generation", "Admission-season operations"],
    outcomes: ["A differentiated brand position in the Pune B-School market", "An admission funnel measurable at every stage", "Repeatable admission-season playbooks"],
  },
  {
    slug: "dy-patil",
    name: "D.Y. Patil", city: "Pune",
    services: ["Digital Marketing", "Calling", "Admissions", "Events"],
    tagline: "Scaled marketing and admission operations for a marquee university brand.",
    overview: "A3 supports D.Y. Patil's Pune campus programs with performance marketing, calling operations and student engagement events that match the scale of the brand.",
    deliverables: [
      { title: "Digital Marketing", desc: "Large-scale performance campaigns with granular program-level targeting and reporting." },
      { title: "Calling", desc: "High-volume inbound and outbound calling operations with IVR and AI-assisted workflows." },
      { title: "Admissions", desc: "End-to-end enquiry-to-enrolment support coordinated with campus admission teams." },
      { title: "Events", desc: "Education fairs, campus drives and corporate interaction events." },
    ],
    approach: ["Program portfolio mapping", "Campaign architecture", "Calling operations at scale", "Event & campus activation"],
    outcomes: ["Marketing operations that keep pace with a large program portfolio", "Consistent aspirant experience across thousands of touchpoints", "Deeper engagement through on-ground activations"],
  },
  {
    slug: "ibmr",
    name: "IBMR", city: "Gurugram",
    services: ["Website / Technology", "Digital Marketing", "Lead Generation", "Branding"],
    tagline: "A complete growth stack for a Gurugram business school.",
    overview: "IBMR partnered with A3 for an integrated growth engagement — digital infrastructure, demand generation and a sharper institutional brand for the NCR market.",
    deliverables: [
      { title: "Website / Technology", desc: "Modern institutional website, program landing pages and CRM-integrated lead systems." },
      { title: "Digital Marketing", desc: "SEO, Google and Meta performance campaigns tuned for the NCR aspirant market." },
      { title: "Lead Generation", desc: "Steady aspirant pipelines with qualification, distribution and analytics." },
      { title: "Branding", desc: "Brand strategy, creative campaigns and digital reputation management." },
    ],
    approach: ["Growth audit", "Digital foundation build", "Performance launch", "Brand acceleration"],
    outcomes: ["A single accountable partner across the growth stack", "Better funnel visibility from click to counselling", "A stronger, more consistent brand in the NCR market"],
  },
];

export const TESTIMONIALS = [
  { name: "Arjun Mehta", program: "PGDM · FOSTIIMA Business School, Delhi", placed: "Placed at HDFC Bank", quote: "I was lost between 20 college brochures. One counselling call gave me a clear shortlist, honest fee guidance and a college that actually fit my CAT percentile.", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80" },
  { name: "Priya Sharma", program: "MBA · D.Y. Patil, Pune", placed: "Placed at Deloitte", quote: "The team helped me compare placements and specialisations across cities — not just push one college. That's why I trusted them with my application too.", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80" },
  { name: "Rohit Verma", program: "PGDM · IIBS, Bangalore", placed: "Placed at TCS", quote: "From my first enquiry to the GDPI prep session, every step was guided. I moved from Lucknow to Bangalore with total clarity about what I was signing up for.", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80" },
  { name: "Sneha Kulkarni", program: "PGDM · RIIM, Pune", placed: "Placed at Asian Paints", quote: "My budget was tight and my MAH-CET score average. They still found me a college with genuine ROI instead of overselling. Two years later — best decision ever.", img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80" },
  { name: "Kunal Singh", program: "PGDM · IBMR, Gurugram", placed: "Placed at Axis Bank", quote: "The multi-step application support meant zero missed deadlines. Their follow-up calls kept my admission on track while I was still working full-time.", img: "https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=200&q=80" },
  { name: "Ananya Iyer", program: "MBA · GIBS, Bangalore", placed: "Placed at Infosys", quote: "I compared six colleges on the A3 platform, spoke to a counsellor the same evening and applied within a week. The process felt built for students, not for colleges.", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80" },
];

export const STUDENT_JOURNEY = [
  { n: "01", title: "Discover", desc: "Find colleges matching your goals." },
  { n: "02", title: "Compare", desc: "Compare courses, fees, locations and career opportunities." },
  { n: "03", title: "Connect", desc: "Talk to admission counsellors." },
  { n: "04", title: "Apply", desc: "Get help understanding the application process." },
  { n: "05", title: "Decide", desc: "Make an informed college decision." },
];

export const NODE_FLOW = [
  "College Website", "Digital Marketing", "Leads", "Calling",
  "Counselling", "Admissions", "Students", "Placements", "Growth",
];

export const CITIES = ["All", "Delhi", "Bangalore", "Pune", "Mumbai", "Gurugram", "Greater Noida", "Hyderabad"];
export const COURSES = ["All", "MBA", "PGDM"];
export const EXAMS = ["All", "CAT", "XAT", "CMAT", "MAT", "SNAP", "NMAT", "MAH-CET", "GMAT"];
